module.exports = __webpack_public_path__ + "static/scale-model-of-clearwater-florida-3fa10c71211464d1c3097af57d0f502f.png";